import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProjects, IProjectsInitialState } from "./projectsModal";
import {
  ActiveInactiveProjects,
  createProjects,
  deleteProjects,
  getAllActiveProjects,
  getAllProjects,
  getProjectsByID,
  ProjectsImageUpload,
  updateProjects,
} from "./services/projects.services";

const initialState: IProjectsInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  ProjectsID: null,
  ProjectsList: [],
  ProjectsDetail: {
    ID: null,
    ProjectTitle: "",
    ProjectURL: "",
    Description: "",
    MetaTitle: "",
    MetaKeyword: "",
    MetaDescription: "",
    MainImage: "",
    IsActive: 1,
    InnerImages: [],
  },
};

const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    clearProjectsDetails: (state) => {
      state.ProjectsDetail = initialState.ProjectsDetail;
    },
    setProjectsID: (state, action) => {
      state.ProjectsID = action.payload;
    },
    clearProjectsID: (state) => {
      state.ProjectsID = initialState.ProjectsID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllProjects.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllProjects.fulfilled,
      (state, action: PayloadAction<IProjects[]>) => {
        state.loading = false;
        state.ProjectsList = action.payload || [];
      }
    );
    builder.addCase(getAllProjects.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ProjectsList = [];
    });
    builder.addCase(createProjects.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createProjects.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createProjects.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateProjects.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateProjects.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateProjects.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteProjects.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteProjects.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteProjects.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(ProjectsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ProjectsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ProjectsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getProjectsByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getProjectsByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.ProjectsDetail = action.payload;
    });
    builder.addCase(getProjectsByID.rejected, (state, action) => {
      state.loading = false;
      state.ProjectsDetail = initialState.ProjectsDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveProjects.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveProjects.fulfilled,
      (state, action: PayloadAction<IProjects[]>) => {
        state.loading = false;
        state.ProjectsList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveProjects.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ProjectsList = [];
    });
    builder.addCase(ActiveInactiveProjects.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveProjects.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveProjects.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearProjectsDetails, clearProjectsID, setProjectsID } =
  projectsSlice.actions;
export default projectsSlice.reducer;
